import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "mb-8 md:mb-12" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "text-sm text-gray-600" }
const _hoisted_5 = {
  key: 0,
  class: "px-4 py-3 border border-yellow-300 bg-yellow-50 text-sm text-yellow-800 rounded"
}
const _hoisted_6 = { class: "w-full md:w-1/3 mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "px-4 py-3 border border-blue-200 bg-blue-50 text-sm rounded"
}
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_10 = { class: "hidden md:flex flex-row items-center text-light font-bold text-headings-gray mb-4 px-6" }
const _hoisted_11 = { class: "w-1/4" }
const _hoisted_12 = { class: "w-5/12" }
const _hoisted_13 = { class: "w-1/3" }
const _hoisted_14 = { class: "w-full md:w-1/4 font-semibold break-words" }
const _hoisted_15 = { class: "w-full md:w-5/12 md:pr-4" }
const _hoisted_16 = { class: "text-small text-gray-600 mt-1" }
const _hoisted_17 = { class: "w-full md:w-1/3" }
const _hoisted_18 = { class: "text-medium text-center p-3 mb-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("tracking_statuses.title")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("tracking_statuses.description")), 1)
    ]),
    (_ctx.state.isRefused)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("tracking_statuses.not_available")), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FormInput, {
              elementData: _ctx.state.carrierElementData,
              initialState: _ctx.state.carrierInitialState,
              onFormInputValueUpdate: _ctx.methods.carrierChange
            }, null, 8, ["elementData", "initialState", "onFormInputValueUpdate"])
          ]),
          (_ctx.state.table)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.state.table.coverage), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.table.notes, (note, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: index,
                    class: "mt-2"
                  }, _toDisplayString(note), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.isLoading)
            ? (_openBlock(), _createBlock(_component_spinner, {
                key: 1,
                class: "mx-auto mt-6"
              }))
            : _createCommentVNode("", true),
          (_ctx.state.table && !_ctx.state.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("tracking_statuses.labels.code")), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("tracking_statuses.labels.meaning")), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("tracking_statuses.labels.effect")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.table.rows, (row) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row.code,
                    class: _normalizeClass(["flex flex-col md:flex-row md:items-center text-light rounded border p-4 mb-1 md:px-6", _ctx.toneClasses[row.tone]])
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(row.code), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", null, _toDisplayString(row.description || _ctx.$t("tracking_statuses.no_definition")), 1),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(row.source || _ctx.$t("tracking_statuses.no_source")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(row.group), 1)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(_component_modal, {
      type: "warning",
      size: "small",
      hideCancelButton: true,
      modelValue: _ctx.state.showModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.showModal) = $event)),
      onConfirmClick: _ctx.methods.closeModal,
      onCancelClick: _ctx.methods.closeModal
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("tracking_statuses.modal.title")), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("tracking_statuses.modal.general_error")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick", "onCancelClick"])
  ]))
}